import { formatNumber } from '@progress/kendo-intl'

/**
 * 数値をフォーマットします。
 *
 * @param value - 数値。
 * @returns フォーマットされた文字列。
 */
export function format(value: number): string {
  return formatNumber(value, 'n0')
}
